import { DocumentList } from '../../components/Library/Guest'

export const Library = () => {
    return <DocumentList />
}
